import { useMutation } from '@tanstack/react-query';
import { LoginApi } from '../../../apis/LoginApi/LoginApi.ts';

export function usePostResetPasswordMutation() {
    return useMutation<
        string,
        Error,
        {
            userID: number;
            token: string;
            newPassword: string;
        }
    >({
        mutationFn: async ({ userID, token, newPassword }) => {
            return LoginApi.resetPassword({ userID, token, newPassword });
        },
    });
}
